import type { TDocument } from '../types';

// The one switch for form-field editors.
export const usesFormFields = (doc: Pick<TDocument, 'parentType'>): boolean => doc.parentType === 'CHANGE_TEMPLATE';
